<script setup lang="ts">
import { shortId } from '../utils/string';

defineProps({
    label: {
        type: String,
        default: ''
    }
});

const inputId = ref(shortId());

</script>

<template>
    <label :for="inputId" style="user-select: none">
        <VLColorPicker
            :input-id="inputId"
            binary
            class="mr-2"
            v-bind="$attrs"
        />
        {{ label }}
    </label>
</template>

